/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 25 2025
 **/

import { useEffect, useMemo, useRef, useState } from "react";

import useWhiteboardStore from "@/stores/useWhiteboardStore";

export default function useDraggable() {
	const windowState = useWhiteboardStore((state) => state.windowState);
	const isOpen = useWhiteboardStore((state) => state.isOpen);

	const nodeRef = useRef<HTMLDivElement>(null);
	const [position, setPosition] = useState<Vector2>({ x: 0, y: 0 });

	useEffect(() => {
		if (isOpen) setPosition({ x: 0, y: 0 });
	}, [isOpen]);

	const draggableOptions = useMemo(() => {
		const minimized = windowState === "minimize";
		return {
			disabled: !minimized,
			position: minimized ? position : { x: 0, y: 0 },
			positionOffset: minimized ? { x: "-50%", y: "-50%" } : { x: 0, y: 0 },
			bounds: {
				left: -window.innerWidth / 2,
				top: -window.innerHeight / 2,
				right: window.innerWidth / 2,
				bottom: window.innerHeight / 2
			},
			onStop: (_: unknown, data: Vector2) => setPosition({ x: data.x, y: data.y })
		};
	}, [windowState, position]);

	return { draggableOptions, nodeRef };
}
